import Vue from 'vue'
import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { ExportCatalogType } from '@/enum/ExportCatalogType'

Vue.filter('fluxType', function(value: ExportCatalogType ) {
  if (value) {
    switch(value){
      case ExportCatalogType.Offers:
        return 'Produits'
      case ExportCatalogType.Tree:
        return 'Famille'      
      case ExportCatalogType.OffersAndTree:
        return 'Tous'      
    }        
    return ''
  }
})